import {
  COACHING_TYPE,
  LIGHTING,
  RECEPTION_CAPACITY_TYPE,
  SURFACE_AREA,
  VENUE_TYPE,
  type StudioEnvironment,
} from "@academy-context/shared/domain/types/studio-environment";

export const mockStudioEnvironment: StudioEnvironment = {
  externalUrl: null,
  venueType: VENUE_TYPE.PERSONAL_STUDIO,
  coachingTypes: [COACHING_TYPE.VOICE],
  receptionCapacity: { type: RECEPTION_CAPACITY_TYPE.INDIVIDUAL, maxPeople: null },
  materialConditions: {
    surfaceArea: SURFACE_AREA.FROM_10_TO_20,
    lighting: LIGHTING.NATURAL,
    hasVentilation: true,
    hasHeating: true,
    hasWaterAndSanitary: true,
    hasSoundproofing: true,
  },
  safetyConditions: { hasSmokeDetector: true, hasFireExtinguisher: true },
  hasHostingHonorAttestation: true,
};
